export const seoConfig = {
    defaultTitle: '儿童绘本阅读 - 让阅读成为孩子成长的翅膀',
    defaultDescription: '专业的儿童绘本推荐平台，提供0-12岁儿童绘本、早教绘本、情商教育、行为习惯培养等优质内容。让每个孩子都能享受阅读的乐趣，培养终身学习的能力。',
    defaultKeywords: '儿童绘本,幼儿绘本,绘本故事,亲子阅读,儿童阅读,早教绘本,绘本推荐',
    
    // 各页面SEO配置
    pages: {
        // 首页 - 整合所有关键词
        home: {
            title: '首页 - 更有温度，更专业的儿童阅读馆',
            description: '专业的儿童绘本推荐平台，提供绘本分类导航、热门推荐、新书速递等服务。包含艾瑞·卡尔、宫西达也等经典绘本，蒲蒲兰、信谊等知名出版社作品，以及情感教育、行为习惯、认知启蒙等主题内容。针对0-3岁、3-6岁等不同年龄段提供科学的分级阅读指导。',
            keywords: [
                // 核心关键词-基础词
                '儿童绘本推荐,幼儿绘本故事,儿童绘本排行榜,儿童阅读方法,亲子阅读技巧,儿童读物推荐,儿童阅读,绘本故事,绘本阅读,儿童故事,幼儿阅读,绘本教育,早教绘本,绘本推荐,亲子阅读,儿童绘本',
                
                // 核心关键词-年龄分类
                '0-3岁绘本推荐,3-6岁绘本故事,学前儿童绘本,幼儿园绘本教育,小学生课外阅读,婴儿绘本,学龄前绘本,低幼绘本,幼儿园绘本,儿童启蒙绘本',
                
                // 核心关键词-场景词
                '睡前故事绘本,儿童情商绘本,行为习惯绘本,安全教育绘本,亲子共读技巧,入园绘本,入学准备绘本,生命教育绘本,性教育绘本,数学启蒙绘本,英文绘本,双语绘本',
                
                // 品牌关键词-出版社
                '蒲蒲兰绘本,信谊绘本,布克绘本,海豚绘本,米小圈绘本,启发绘本,童立方绘本,阳光绘本,乐乐趣绘本,步印童书',
                
                // 长尾关键词
                '如何培养孩子阅读习惯,幼儿园绘本教育经验分享,儿童绘本故事在线听,儿童早教绘本怎么选,宝宝不爱看书怎么办,绘本阅读的重要性,如何选择适合孩子的绘本,亲子阅读的好处,绘本阅读的正确方法,绘本阅读环境布置,亲子阅读时间安排,绘本阅读年龄规划',
                
                // 经典绘本系列
                '好饿的毛毛虫,从头动到脚,棕色的熊,月亮你好,我是霸王龙,你看起来好像很好吃,永远永远爱你,世界上最爱我的妈妈,我爸爸,我妈妈,猩猩爸爸,小威利,艾瑞·卡尔系列,宫西达也系列,安东尼·布朗系列',
                
                // 主题分类绘本
                '猜猜我有多爱你,爱你宝贝,我爱你,窗边的小豆豆,大卫不可以系列,我不想上学,波比在图书馆,乖乖吃饭,小兔汤姆系列,坏脾气小红龙,是谁嗯嗯在我的头上,爱生气的大象,小鼠波波系列,小熊维尼系列,彩虹鱼系列,青蛙弗洛格系列,快乐的小青蛙,一只想飞的猫,阿福一家系列,小狗钱钱'
            ].join(',')
        },

        // 会员服务
        membership: {
            title: '会员服务 - 专属的绘本阅读体验',
            description: '提供优质的会员服务，包括绘本借阅、主题活动、阅读指导等特权。让每个孩子都能享受高品质的阅读服务。',
            keywords: '绘本借阅,儿童图书馆,阅读馆会员,亲子阅读活动,儿童阅读指导,绘本订阅,早教中心'
        },

        // 书单
        bookList: {
            title: '精选书单 - 优质绘本推荐',
            description: '精心筛选的绘本书单，包括获奖作品、畅销书籍、主题推荐等。根据年龄、主题、场景等多维度为您推荐合适的绘本。',
            keywords: '绘本推荐,儿童绘本排行榜,经典绘本,主题绘本,分龄绘本,获奖绘本,畅销绘本,优质绘本'
        },

        // 活动
        events: {
            title: '主题活动 - 丰富的阅读体验',
            description: '定期举办绘本故事会、亲子阅读工作坊、主题创作等特色活动。通过互动体验提升阅读乐趣，培养阅读兴趣。',
            keywords: '绘本故事会,亲子阅读活动,儿童创意工作坊,主题活动,亲子互动,读书会,阅读营'
        },

        // 关于我们
        aboutUs: {
            title: '关于我们 - 专注儿童阅读教育',
            description: '我们致力于为中国家庭提供优质的儿童阅读解决方案，推广科学的亲子阅读方法，让更多孩子爱上阅读。',
            keywords: '儿童阅读,亲子阅读,绘本教育,早教启蒙,儿童教育,绘本馆,儿童图书馆'
        },

        // 团队介绍
        team: {
            title: '专业团队 - 富有经验的阅读指导者',
            description: '我们的团队由儿童教育专家、绘本研究者、早教工作者等专业人士组成，为孩子的阅读成长保驾护航。',
            keywords: '阅读指导师,儿童教育专家,绘本老师,早教老师,阅读推广人'
        },

        // 联系我们
        contact: {
            title: '联系我们 - 随时为您服务',
            description: '欢迎通过电话、邮件或实地访问与我们联系，了解更多关于绘本阅读的服务。期待为您的孩子提供专业的阅读指导。',
            keywords: '阅读馆地址,联系方式,预约咨询,客户服务,意见反馈'
        },

        // 注册
        registration: {
            title: '加入我们 - 开启阅读之旅',
            description: '简单几步即可成为会员，享受专业的绘本阅读服务。提供多种会员方案，满足不同家庭的需求。',
            keywords: '会员注册,开通会员,会员服务,会员权益,绘本订阅'
        },

        // 分龄阅读
        ageGroups: {
            title: '分龄阅读 - 科学的儿童绘本分级体系',
            description: '按年龄段精选绘本，0-3岁、3-6岁、6-12岁分级推荐。针对不同年龄段儿童的认知特点和阅读能力，提供最适合的绘本。',
            keywords: '0-3岁绘本推荐,3-6岁绘本故事,学前儿童绘本,幼儿园绘本教育,小学生课外阅读,婴儿绘本,学龄前绘本,低幼绘本'
        },

        // 主题绘本
        themes: {
            title: '主题绘本 - 多维度培养孩子成长',
            description: '精选情感、习惯、认知、性格等多个主题的优质绘本。通过绘本故事培养孩子良好的品格和习惯，提升情商和认知能力。',
            keywords: '情感教育绘本,行为习惯绘本,性格培养绘本,认知启蒙绘本,安全教育绘本,生命教育绘本,性教育绘本'
        },

        // 品牌绘本
        brands: {
            title: '品牌绘本 - 优质出版社精选',
            description: '汇集蒲蒲兰、信谊、启发等知名出版社的精品绘本，为孩子提供优质的阅读内容。精选全球顶级出版社的优质绘本作品。',
            keywords: '蒲蒲兰绘本,信谊绘本,启发绘本,海豚绘本,童立方绘本,米小圈绘本,阳光绘本,乐乐趣绘本,步印童书'
        },

        // 经典绘本
        classics: {
            title: '经典绘本 - 永恒的儿童文学珍藏',
            description: '收录艾瑞·卡尔、宫西达也等世界著名绘本作家的经典作品，让孩子遇见最美的绘本故事。精选全球经典绘本系列。',
            keywords: '好饿的毛毛虫,我是霸王龙,你看起来好像很好吃,永远永远爱你,我爸爸,我妈妈,猩猩爸爸,小威利,艾瑞·卡尔,宫西达也'
        },

        // 场景阅读
        scenes: {
            title: '场景绘本 - 贴近生活的阅读体验',
            description: '针对不同场景和需求精选绘本，包括睡前故事、情商培养、行为习惯、安全教育等主题，让阅读自然融入生活。',
            keywords: '睡前故事绘本,儿童情商绘本,行为习惯绘本,安全教育绘本,入园绘本,入学准备绘本,数学启蒙绘本,英文绘本,双语绘本'
        },

        // 阅读指南
        guide: {
            title: '绘本阅读指南 - 科学的亲子阅读方法',
            description: '提供专业的绘本阅读指导，帮助家长培养孩子的阅读习惯，创造良好的阅读环境。分享实用的亲子阅读技巧和经验。',
            keywords: '如何培养孩子阅读习惯,绘本阅读的重要性,如何选择适合孩子的绘本,亲子阅读的好处,绘本阅读的正确方法,亲子阅读时间安排'
        }
    }
}; 